// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cls-1[data-v-c4b113da]{fill:#febf7c}.cls-2[data-v-c4b113da]{fill:var(--v-primary-base)}.cls-3[data-v-c4b113da]{fill:#fbe096}.cls-4[data-v-c4b113da]{fill:#e19c53}", ""]);
// Exports
module.exports = exports;
